import * as Sentry from '@sentry/react';
import { FeatureFlag, checkFeatureFlag } from 'hooks/useFeatureFlag';
import { getSentryEnvironment } from 'util/env';

export const initializeSentry = () => {
  const enableFeedback = checkFeatureFlag(FeatureFlag.ENABLE_FEEDBACK);

  Sentry.init({
    dsn: 'https://e14dcf2851ea739574f10f7a275ed148@o4510068029849600.ingest.de.sentry.io/4510073361203280',
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    enableLogs: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: getSentryEnvironment(),
    release: import.meta.env.VITE_SENTRY_RELEASE ?? 'unknown-plant-designer',
  });

  void import('./sentryReplay').then(
    ({ replayCanvasIntegration, replayIntegration }) => {
      Sentry.addIntegration(replayCanvasIntegration());
      Sentry.addIntegration(
        replayIntegration({ maskAllText: false, blockAllMedia: false }),
      );
    },
    (error: unknown) => {
      console.warn('Failed to load Sentry replay integration', error);
    },
  );

  if (enableFeedback) {
    void import('./sentryFeedback').then(
      ({ feedbackIntegration }) => {
        Sentry.addIntegration(
          feedbackIntegration({ colorScheme: 'system', showBranding: false }),
        );
      },
      (error: unknown) => {
        console.warn('Failed to load Sentry feedback integration', error);
      },
    );
  }
};
